import { cn } from "@nimbitlabs/ui";
import { ReactNode } from "react";

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

const GlassCard = ({ children, className, hover = true }: GlassCardProps) => {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-2xl p-6 transition-all duration-300",
        hover && "hover:bg-secondary/30 hover:border-primary/30 hover:shadow-lg",
        className
      )}
    >
      {children}
    </div>
  );
};

export default GlassCard;
